/**
 * Intl polyfill (intl + intl-locales-supported) was removed; Node 18+ and current
 * browsers provide Intl for supported storefront locales.
 */
export const importIntlPolyfill = async (): Promise<void> => {}

export const checkForIntlPolyfill = async (_storeView?: unknown): Promise<void> => {}
